var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", {
    id: "defs13",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath23",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path21",
    fill: "#000000",
    "data-original": "#000000",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19",
    clipPath: "url(#clipPath23)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(376,15)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -240 c -16.568,0 -30,13.431 -30,30 v 422 c 0,16.569 13.432,30 30,30 H 0 c 16.568,0 30,-13.431 30,-30 V 30 C 30,13.431 16.568,0 0,0 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path27",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(226,437)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 60",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path31",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "translate(271,75)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 10
    },
    id: "path35",
    fill: "#000000",
    "data-original": "#000000",
    strokeWidth: 10
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5f21d9ea3029634c49aaff58bf68ae37.svg";
export { ForwardRef as ReactComponent };